import React from 'react';
import SvgIconDPC from "../dpc-svg-icon";

export default class DpcCard extends React.Component {

    getText(text){
        if(!text || typeof text !== "string")
            return "";

        const regex = /(( ?)<\/?(?:a)[^>]*>)|<[^>]+>( ?)/ig;
        const subst = `$1`;
        const body = text.replace(regex, subst);

        if(body.length <= 150)
            return body;
        const subString = body.substr(0, 149);
        return subString.substr(0, subString.lastIndexOf(" ")) + "...";
    }

    render(){
        return (
            <article className="card-wrapper card-space">
                <div className="card card-img">
                        <div className="img-responsive-wrapper">
                            <div className="img-responsive">
                                {this.props.image &&
                                <figure className='img-wrapper'>
                                    <figcaption className="sr-only">{this.props.image?.field_didascalia }</figcaption>
                                    <a href={this.props.slug}>
                                        <img  alt={this.props.image?.field_alt} src={this.props.image?.relationships?.image?.localFile?.publicURL}/>
                                    </a>

                                </figure>
                                }
                            </div>
                        </div>
                    <div className="card-body">
                        {this.props.categoria ? (
                            <div className="category-top">
                                <span className="category">{this.props.categoria.replace('_', ' ')}</span>
                            </div>
                        ) : null}
                        {this.props.leggiDiPiu?
                            <a className="read-more" href={this.props.slug}>
                                <span className="text">{this.props.leggiDiPiu}</span>
                                <SvgIconDPC name={'arrow-right'}/>
                            </a>
                            : null}
                        <h3 className="card-title"><a href={this.props.slug}>{this.props.title}</a></h3>
                        <div className="card-text" dangerouslySetInnerHTML={{__html: this.getText(this.props.body)}}/>
                    </div>
                </div>
            </article>
        )
    }
}
